import config from '../../utils/config';

var df_data = {
    //刷新主数据
    base_reload: false,

    //菜单有关
    menu_active_name: "",//激活菜单的 name 值

    //已打开的界面
    menu_opens: [],
    menu_opens_name: []
};

const state = df_data;

const actions = {
    setBaseData_baseReload (content, value) {
        state.base_reload = value
    },

    setBaseData_Menu (content, data) {
        state.menu_active_name = data.active_name
    },

    clearBaseData_MenuOpens (content) {
        state.menu_opens.splice(0, state.menu_opens.length);
        state.menu_opens_name.splice(0, state.menu_opens_name.length);
    },
    delBaseData_MenuOpens (content, index) {
        state.menu_opens.splice(index, 1);
        state.menu_opens_name.splice(index, 1);
    },
    setBaseData_MenuOpens (content, data) {
        state.menu_opens.filter(item => item.curr == 1).map(item => (item.curr = 0));
        var fid = data.fid;//程序ID
        var has = state.menu_opens.filter(item => item.fid == fid)[0];
        if (has) {
            has['curr'] = 1;
            has['fn'] = data.fn;
            has['url'] = data.url;
        }
        else {
            if (state.menu_opens.length == config.cache_page_qty) {
                state.menu_opens.splice(0, 1);
                state.menu_opens_name.splice(0, 1);
            }
            state.menu_opens.splice(state.menu_opens.length, 0, {
                fid: fid,//程序ID
                fn: data.fn,//程序名称
                url: data.url,//路径
                curr: 1,//状态
            });
            var names = data.path.split('/');
            var name = names[1] + '-' + names[2];
            state.menu_opens_name.splice(state.menu_opens.length, 0, name);
        }
    },
};

export default {
    state,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/baseData.js